import { render, staticRenderFns } from "./posterCard.vue?vue&type=template&id=f68f415c&"
import script from "./posterCard.vue?vue&type=script&lang=js&"
export * from "./posterCard.vue?vue&type=script&lang=js&"
import style0 from "./posterCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports